import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IIHCAdministratorApplication } from 'app/models/licenses/in-home-care/ihc-administrator-application';
import { IIHCManagementExperience } from 'app/models/licenses/in-home-care/ihc-management-experience';
import { IIHCProfessionalExperience } from 'app/models/licenses/in-home-care/ihc-professional-experience';

@Injectable({providedIn: 'root'})
export class AdministratorApplicationService {
  private api: string = environment.privateApi + 'AdministratorApplication/';
  private http = inject(HttpClient);

  public createAdministratorApplication(entityId: number, entityType: string): Observable<IIHCAdministratorApplication> {
    return this.http.post<IIHCAdministratorApplication>(this.api + 'CreateAdministratorApplication/' + entityId + '/' + entityType, null);
  }

  public getAdministratorApplication(entityId: number, entityType: string): Observable<IIHCAdministratorApplication> {
    return this.http.get<IIHCAdministratorApplication>(this.api + 'GetAdministratorApplication/' + entityId + '/' + entityType);
  }

  public updateAdministratorApplication(application: IIHCAdministratorApplication): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateAdministratorApplication', application);
  }

  public checkIfAdminExists(firstName: string, lastName: string): Observable<boolean>{
    return this.http.get<boolean>(this.api + 'CheckIfAdminExists/' + firstName + '/' + lastName);
  }

  public getManagementExperiences(applicationId: number, includeArchived: boolean): Observable<IIHCManagementExperience[]>{
    return this.http.get<IIHCManagementExperience[]>(this.api + 'GetManagementExperiences/' + applicationId + '/' + includeArchived);
  }

  public createManagementExperience(experience: IIHCManagementExperience): Observable<IIHCManagementExperience>{
    return this.http.post<IIHCManagementExperience>(this.api + 'CreateManagementExperience', experience);
  }

  public updateManagementExperience(experience: IIHCManagementExperience): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateManagementExperience', experience);
  }

  public archiveManagementExperience(experienceId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveManagementExperience/' + experienceId + '/' + archive, null);
  }

  public deleteManagementExperience(experienceId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteManagementExperience/' + experienceId);
  }

  public getProfessionalExperiences(applicationId: number, includeArchived: boolean): Observable<IIHCProfessionalExperience[]>{
    return this.http.get<IIHCProfessionalExperience[]>(this.api + 'GetProfessionalExperiences/' + applicationId + '/' + includeArchived);
  }

  public createProfessionalExperience(experience: IIHCProfessionalExperience): Observable<IIHCProfessionalExperience>{
    return this.http.post<IIHCProfessionalExperience>(this.api + 'CreateProfessionalExperience', experience);
  }

  public updateProfessionalExperience(experience: IIHCProfessionalExperience): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateProfessionalExperience', experience);
  }

  public archiveProfessionalExperience(experienceId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveProfessionalExperience/' + experienceId + '/' + archive, null);
  }

  public deleteProfessionalExperience(experienceId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteProfessionalExperience/' + experienceId);
  }
}
